import { IAppState } from '../../redux';
import { EAccountType } from '../../redux/reducers';

export const selectBillingUserType = (state: IAppState): EAccountType | null => {
  return state.user.billingInfo?.accountType || null;
};
